import { render, staticRenderFns } from "./score-table.component.vue?vue&type=template&id=1673c12e&scoped=true&"
import script from "./score-table.component.vue?vue&type=script&lang=ts&"
export * from "./score-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./score-table.component.vue?vue&type=style&index=0&id=1673c12e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673c12e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular})
